import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  markInvoiceRefunded,
  markInvoiceDeniedToPay,
  markInvoicePaidAmount,
  setInvoiceSentReminders,
} from 'actions/InvoiceActions';
import Loader from 'components/layout/Loader';
import { Button, FormGroup, FormControl, InputGroup, Row, Col } from 'react-bootstrap';
import LiaPanel from './LeadInvoiceActionsPanel';
import FormSwitchery from '../../forms/FormSwitchery';
import may from "../../../security";

class LeadInvoiceActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: 0,
      reminders: 0,
      isHydrated: false,
    };
  }

  handleAmountChange = event => {
    const { value } = event.target;
    const amount = value.replace(/,/g, '.');

    this.setState({ amount });
  };

  handleRemindersChange = event => {
    const { value } = event.target;
    const reminders = parseInt(value, 10);

    this.setState({ reminders });
  };

  render() {
    const {
      invoices,
      markInvoiceRefunded,
      markInvoiceDeniedToPay,
      markInvoicePaidAmount,
      setInvoiceSentReminders,
      user,
      appIntl: {
        messages: { messages },
      },
    } = this.props;

    const { amount, reminders, isHydrated } = this.state;

    if (invoices.pending) {
      return <Loader />;
    }

    const invoice = invoices.data.list.filter(invoice => invoice.type === 'invoice').shift();

    if (!invoice) {
      return <p>Invoice not found</p>;
    }

    const {
      payment_info: { payed: invoicePayed, amount: invoiceAmount },
      sent_reminders: sentReminders,
      is_manually_refunded: isManuallyRefunded,
      is_denied_to_pay: isDeniedToPay,
    } = invoice;

    if (!isHydrated) {
      this.setState({
        amount: invoicePayed || invoiceAmount,
        reminders: sentReminders,
        isHydrated: true,
      });
    }

    const listName = 'invoices';

    // Mark as Refunded
    const txtMAR = messages.invoice_actions.refunded;
    const panelMAR = {
      title: txtMAR.title,
      body: (
        <FormSwitchery
          checked={isManuallyRefunded}
          infoText={txtMAR.info_text}
          label={txtMAR.label}
          name="is refunded"
          onChange={(_, value) => markInvoiceRefunded(invoice, value, listName)}
          value
        />
      ),
    };

    // Mark as Denied to Pay
    const txtDTP = messages.invoice_actions.denied_to_pay;
    const panelDTP = {
      title: txtDTP.title,
      body: (
        <FormSwitchery
          checked={isDeniedToPay}
          infoText={txtDTP.info_text}
          label={txtDTP.label}
          name="denied to pay"
          onChange={(_, value) => markInvoiceDeniedToPay(invoice, value, listName)}
          value
        />
      ),
    };

    // Manually enter amount paid
    const txtMAP = messages.invoice_actions.amount_paid;
    const panelPaid = {
      title: txtMAP.title,
      body: (
        <>
          <FormGroup>
            <InputGroup>
              <FormControl
                type="text"
                placeholder={txtMAP.placeholder}
                value={amount}
                onChange={this.handleAmountChange}
              />
              <InputGroup.Addon>{'\u20AC'}</InputGroup.Addon>
              {/* \u20AC is EUR sign Unicode symbol */}
            </InputGroup>
          </FormGroup>
          <Button
            block
            bsSize="sm"
            className="m-t-1"
            bsStyle="primary"
            onClick={() => markInvoicePaidAmount(invoice, amount, listName)}
          >
            {txtMAP.button}
          </Button>
        </>
      ),
    };

    // Enter number of due reminders sent
    const txtREM = messages.invoice_actions.sent_reminders;
    const panelReminders = {
      title: txtREM.title,
      body: (
        <>
          <FormGroup>
            <InputGroup>
              <FormControl
                type="text"
                placeholder={txtREM.placeholder}
                value={reminders}
                onChange={this.handleRemindersChange}
              />
              <InputGroup.Addon>
                <i class="far fa-envelope" />
              </InputGroup.Addon>
            </InputGroup>
          </FormGroup>
          <Button
            block
            bsSize="sm"
            className="m-t-1"
            bsStyle="primary"
            onClick={() => setInvoiceSentReminders(invoice, reminders, listName)}
          >
            {txtREM.button}
          </Button>
        </>
      ),
    };

    return (
      <div className="clearfix padding-20 sm-padding-10">
        <Row>
          <Col xs={12} md={6} lg={3}>
            {may('ROLE_ROOT_EMPLOYEE', user.roles) && <LiaPanel {...panelMAR} />}
          </Col>
          <Col xs={12} md={6} lg={3}>
            {may('ROLE_ROOT_EMPLOYEE', user.roles) && <LiaPanel {...panelDTP} />}
          </Col>
          <Col xs={12} md={6} lg={3}>
            {may('ROLE_ROOT_EMPLOYEE', user.roles) && <LiaPanel {...panelPaid} />}
          </Col>
          <Col xs={12} md={6} lg={3}>
            {may('ROLE_ROOT_EMPLOYEE', user.roles) && <LiaPanel {...panelReminders} />}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    invoices: state.list.invoices,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    markInvoiceRefunded: (invoice, value, listName) => dispatch(markInvoiceRefunded(invoice, value, listName)),
    markInvoiceDeniedToPay: (invoice, value, listName) => dispatch(markInvoiceDeniedToPay(invoice, value, listName)),
    markInvoicePaidAmount: (invoice, amount, listName) => dispatch(markInvoicePaidAmount(invoice, amount, listName)),
    setInvoiceSentReminders: (invoice, value, listName) => dispatch(setInvoiceSentReminders(invoice, value, listName)),
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadInvoiceActions)
);
